/* eslint-disable jsx-a11y/no-static-element-interactions */
export const ReturnConfigModalTitle = ({ entityName, catHierarchy }) => (
  <div className='tw-w-full tw-flex tw-justify-between tw-items-center tw-pb-7 tw-border tw-border-solid !tw-border-x-0 !tw-border-t-0 tw-border-b-grey-200'>
    <div className='tw-flex tw-gap-2 tw-w-full'>
      <div className='tw-flex tw-flex-col tw-gap-4 tw-w-full'>
        <span className='tw-text-[1.8rem] tw-font-medium tw-leading-none'>
          {entityName}
        </span>
        {catHierarchy && (
          <span className='tw-text-[1.5rem] tw-text-green-700 tw-font-medium tw-leading-none'>
            {catHierarchy}
          </span>
        )}
      </div>
    </div>
  </div>
);
